const useGetResponseData = () => {

  const getExtractionInitial = (responseContent, parentId) => {
    // return { treeViewFormat:"$", treeData:"$", isParentIsArray:Array.isArray(responseContent)}
    return { treeViewFormat:"" + parentId + "", treeData: "" + parentId + ""
    , isParentIsArray:Array.isArray(responseContent), isFirsArrayRow:Array.isArray(responseContent)}
  }

  const getResponseData = (data, parentId) => {
    var treeData = []
    var schemaData = []
    
    var responseContent = JSON.parse(JSON.stringify(data))
    convertJsonToTreeData(responseContent, treeData, schemaData, getExtractionInitial(responseContent, parentId))
    return {treeData:treeData, schemaData:schemaData}
    
  }

  const convertJsonToTreeData = (jsonResponse, treeViewFormat=[], structData =[], parentId) => {
    //, parentId = { treeViewFormat:parentId, treeData:parentId, isParentIsArray:undefined}) => {
    if (!jsonResponse || jsonResponse == null) return
    Object.entries(jsonResponse).map(([menu, value], index) => {
      
     
      if (typeof value === 'object') {
        
        let nTreeViewFormat = treeViewFormat.length
        let nTreeData = structData.length
        var isArray = Array.isArray(value)
        
        let newTreeViewFormatId = parentId.treeViewFormat + "_" + index 
        
        if (isArray) treeViewFormat.push({id:newTreeViewFormatId , item:menu, type:"array", childs:[]}) //[]       
        else treeViewFormat.push({id:newTreeViewFormatId , item:menu, type:"object" , childs:[]})
                
        //let newTreeDataId = parentId.treeData + "_" + index 
        if (isArray) {
          //parentId.structDataId = parentId.treeData
          var curentStructData = structData.filter(data => data.item == menu)
          if (curentStructData[0]) { //if (structData.map(data => data.item).includes(menu)) {     
            convertJsonToTreeData(jsonResponse[menu], treeViewFormat[nTreeViewFormat].childs,curentStructData[0].childs, 
              { treeViewFormat:newTreeViewFormatId, treeData:parentId.treeData, isParentIsArray:true})
          }
          else {
            parentId.structDataId = parentId.treeData
            let newTreeDataId = parentId.treeData + "_" + index 
            structData.push({id:newTreeDataId, parentId:parentId.treeData, item:menu, type:"array", childs:[]})
          
            convertJsonToTreeData(jsonResponse[menu], treeViewFormat[nTreeViewFormat].childs,structData[nTreeData].childs, 
              { treeViewFormat:newTreeViewFormatId, treeData:newTreeDataId, isParentIsArray:true})
          }
        }
        else {
          //if current valute is object
          if (!parentId.isParentIsArray ) { // if parent is object //if (!parentId.isParentIsArray || index == 0) {
           // if (!parentId.isParentIsArray) {
              parentId.structDataId = parentId.treeData
              var curentStructData = structData.filter(data => data.item == menu)
              if (curentStructData[0]) { //if (structData.map(data => data.item).includes(menu)) {
               
                convertJsonToTreeData(jsonResponse[menu], treeViewFormat[nTreeViewFormat].childs,curentStructData[0].childs, 
                  { treeViewFormat:newTreeViewFormatId, treeData:parentId.treeData, isParentIsArray:false})
              }
              else {
                let newTreeDataId = parentId.treeData + "_" + index 
                structData.push({id:newTreeDataId, parentId:parentId.treeData, item:menu, type:typeof value, childs:[]})
                convertJsonToTreeData(jsonResponse[menu], treeViewFormat[nTreeViewFormat].childs,structData[nTreeData].childs, 
                  { treeViewFormat:newTreeViewFormatId, treeData:newTreeDataId, isParentIsArray:false})
              }
           // } else
           //   convertJsonToTreeData(jsonResponse[menu], treeViewFormat[nTreeViewFormat].childs,structData, 
            //    { treeViewFormat:newTreeViewFormatId, treeData:newTreeDataId, isParentIsArray:false})
            
          } else { // if parent is array
            
            convertJsonToTreeData(jsonResponse[menu], treeViewFormat[nTreeViewFormat].childs
              ,structData, 
            //{ treeViewFormat:newTreeViewFormatId, treeData:newTreeDataId, isParentIsArray:true}) 
             { treeViewFormat:newTreeViewFormatId, treeData:parentId.treeData, isParentIsArray:false})
          }
          
          
        }
      }
      else {
        // current item is not object
        treeViewFormat.push({id:parentId.treeViewFormat + "_" + index,  item:menu, type: value, childs:[]})
        if (!parentId.isParentIsArray) { // eviter de prendre le contenu des tableaux si ce n'est pas un objet
         
          if (!structData.map(data => data.item).includes(menu)) 
            structData.push({id:parentId.treeData + "_" + structData.length,parentId:parentId.treeData
            ,  item:menu, type: typeof value, childs:[]})
        }
      }           
    })
   // treeIdIndex = treeIdIndex + 1
    
  };
  
  return getResponseData;
};

export default useGetResponseData;
